import getObjectKey from 'lib/object/getObjectKey'

export function getPaymentScheduleKey(payload: App.Checkout.PaymentScheduleRequestInfo | App.Checkout.PaymentScheduleAdjustmentRequestInfo | null): string {
  if (!payload) {
    return 'default'
  }

  return getObjectKey(payload)
}
